import React, { useEffect, useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createProduct } from "../../redux/actions/product";
import { useToast } from "../Layout/Toast/ToastProvider";
import { colorsData } from "../Admin/data";
import { getCategories } from "../../redux/actions/category";
import { getSubcategories } from "../../redux/actions/Subcategory";
import { getSubSubcategories } from "../../redux/actions/subsubcategory";
import { getFilters } from "../../redux/actions/filters";

import styles from "./CreateProduct.module.scss";

const CreateProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { categories = [] } = useSelector((state) => state.category || {});
  const { subcategories = [] } = useSelector((state) => state.subcategories || {});
  const { subsubcategories = [] } = useSelector((state) => state.subsubcategories || {});
  const { filters = [] } = useSelector((state) => state.filters || {});

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState([]);
  const [selectedSubSubcategory, setSelectedSubSubcategory] = useState([]);

  const [showSubProducts, setShowSubProducts] = useState(false);
  const { showToast } = useToast();

  const filteredSubcategories = subcategories.filter((sub) => {
    if (!Array.isArray(sub.parentCategories)) {
      console.warn("Invalid subcategory:", sub);
      return false;
    }

    const parentCategoryIds = sub.parentCategories.map(
      (parent) => parent._id?.toString() || parent.toString()
    );

    return parentCategoryIds.some((parentId) =>
      selectedCategory.some((selectedId) => selectedId.toString() === parentId)
    );
  });

  const filteredSubSubcategories = subsubcategories.filter((subsub) => {
    if (!Array.isArray(subsub.parentSubcategories)) {
      console.warn("Invalid subsubCategory:", subsub);
      return false;
    }

    const parentSubcategoryIds = subsub.parentSubcategories.map(
      (parent) => parent._id?.toString() || parent.toString()
    );

    return parentSubcategoryIds.some((parentId) =>
      selectedSubcategory.some((selectedId) => selectedId.toString() === parentId)
    );
  });

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getSubcategories());
    dispatch(getSubSubcategories());
    dispatch(getFilters());
  }, [dispatch]);

  const { seller } = useSelector((state) => state.seller);
  const { success, error } = useSelector((state) => state.products);

  const [images, setImages] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [originalPrice, setOriginalPrice] = useState();
  const [discountPrice, setDiscountPrice] = useState();

  const [subProduct, setSubProduct] = useState({
    name: "",
    price: "",
    discountPrice: "",
    colors: [],
    images: [],
  });
  const [subProducts, setSubProducts] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({});

  const applicableFilters = filters.filter((filter) => {
    const filterCategoryIds = (filter.categoryId || []).map((cat) => cat._id?.toString() || cat.toString());
    const filterSubcategoryIds = (filter.subcategoryId || []).map((subcat) => subcat._id?.toString() || subcat.toString());
    const filterSubSubcategoryIds = (filter.subsubcategoryId || []).map(
      (subsubcat) => subsubcat._id?.toString() || subsubcat.toString()
    );

    const appliesToCategory = selectedCategory.some((catId) => filterCategoryIds.includes(catId));
    const appliesToSubcategory = selectedSubcategory.some((subcatId) => filterSubcategoryIds.includes(subcatId));
    const appliesToSubSubcategory = selectedSubSubcategory.some((subsubcatId) =>
      filterSubSubcategoryIds.includes(subsubcatId)
    );

    return appliesToCategory || appliesToSubcategory || appliesToSubSubcategory;
  });

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setSelectedCategory((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
    setSelectedSubcategory([]);
    setSelectedSubSubcategory([]);
  };

  const handleSubcategoryChange = (e) => {
    const value = e.target.value;
    setSelectedSubcategory((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const handleSubSubcategoryChange = (e) => {
    const value = e.target.value;
    setSelectedSubSubcategory((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  useEffect(() => {
    if (error) {
      showToast(error, "error");
    }
    if (success) {
      showToast("Product created successfully!", "success");
      navigate("/dashboard");
    }
  }, [dispatch, error, success, navigate, showToast]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages([]);

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setImages((old) => [...old, reader.result]);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemoveImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleColorSelection = (e) => {
    const color = e.target.value;
    if (e.target.checked) {
      setSelectedColors((prev) => [...prev, color]);
    } else {
      setSelectedColors((prev) => prev.filter((c) => c !== color));
    }
  };

  const handleSubProductChange = (e) => {
    const { name, value } = e.target;
    setSubProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubProductColorChange = (e) => {
    const color = e.target.value;
    if (e.target.checked) {
      setSubProduct((prev) => ({
        ...prev,
        colors: [...prev.colors, color],
      }));
    } else {
      setSubProduct((prev) => ({
        ...prev,
        colors: prev.colors.filter((c) => c !== color),
      }));
    }
  };

  const handleSubProductImageChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setSubProduct((prev) => ({
            ...prev,
            images: [...prev.images, reader.result],
          }));
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemoveSubProductImage = (index) => {
    setSubProduct((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
  };

  const addSubProduct = () => {
    if (subProduct.name && subProduct.price) {
      setSubProducts((prev) => [...prev, subProduct]);
      setSubProduct({
        name: "",
        price: "",
        discountPrice: "",
        colors: [],
        images: [],
      });
    } else {
      showToast("Будь ласка заповність всі поля!", "error");
    }
  };

  const handleRemoveSubProduct = (index) => {
    setSubProducts((prev) => prev.filter((_, i) => i !== index));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const category = selectedCategory;
    const subcategory = selectedSubcategory;
    const subsubcategory = selectedSubSubcategory;

    dispatch(
      createProduct({
        name,
        description,
        category,
        subcategory,
        subsubcategory,
        originalPrice,
        discountPrice,
        shopId: seller._id,
        images,
        features: selectedFilters,
        subProducts,
        colors: selectedColors,
      })
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.productContainer}>
        <h5 className={styles.title}>Створити продукт</h5>
        <form onSubmit={handleSubmit} className={styles.form}>
          {/* Назва, опис */}
          <div className={styles.formGroup}>
            <label className={styles.label}>
              Назва продукту <span className={styles.required}>*</span>
            </label>
            <input
              className={styles.input}
              type="text"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Введіть назву продукту..."
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>
              Опис продукту <span className={styles.required}>*</span>
            </label>
            <textarea
              className={styles.textarea}
              cols="30"
              rows="8"
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Введіть детальний опис продукту..."
            ></textarea>
          </div>

          {/* Ціна і знижка */}
          <div className={styles.formGroup2}>
            <div className={styles.price}>
              <label className={styles.label}>Ціна</label>
              <input
                className={styles.input2}
                type="number"
                name="originalPrice"
                value={originalPrice}
                onChange={(e) => setOriginalPrice(e.target.value)}
                placeholder="Введіть ціну продукту..."
              />
            </div>
            <div className={styles.price}>
              <label className={styles.label}>
                Ціна зі знижкою <span className={styles.required}>*</span>
              </label>
              <input
                className={styles.input2}
                type="number"
                name="discountPrice"
                value={discountPrice}
                onChange={(e) => setDiscountPrice(e.target.value)}
                placeholder="Введіть ціну зі знижкою..."
              />
            </div>
          </div>

          {/* Категорії */}
          <div className={styles.formGroup3}>
            <label className={styles.label}>
              Категорії <span className={styles.required}>*</span>
            </label>
            <div className={styles.checkboxGroup}>
              {categories.map((category) => (
                <div key={category._id} className={styles.catButton}>
                  <div className={styles.checkboxWrapper22}>
                    <label
                      className={`${styles.switch} ${styles.round}`}
                      htmlFor={`category-${category._id}`}
                    >
                      <input
                        type="checkbox"
                        id={`category-${category._id}`}
                        value={category._id}
                        checked={selectedCategory.includes(category._id)}
                        onChange={handleCategoryChange}
                      />
                      <div className={styles.slider}></div>
                    </label>
                    <span style={{ marginLeft: "0.5rem" }}>{category.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Субкатегорії */}
          {filteredSubcategories.length > 0 && (
            <div className={styles.formGroup3}>
              <label className={styles.label}>
                Суб Категорії <span className={styles.required}>*</span>
              </label>
              <div className={styles.checkboxGroup}>
                {filteredSubcategories.map((subcategory) => (
                  <div key={subcategory._id} className={styles.catButton}>
                    <div className={styles.checkboxWrapper22}>
                      <label
                        className={`${styles.switch} ${styles.round}`}
                        htmlFor={`subcategory-${subcategory._id}`}
                      >
                        <input
                          type="checkbox"
                          id={`subcategory-${subcategory._id}`}
                          value={subcategory._id}
                          checked={selectedSubcategory.includes(subcategory._id)}
                          onChange={handleSubcategoryChange}
                        />
                        <div className={styles.slider}></div>
                      </label>
                      <span style={{ marginLeft: "0.5rem" }}>
                        {subcategory.name}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Суб-субкатегорії */}
          {filteredSubSubcategories.length > 0 && (
            <div className={styles.formGroup3}>
              <label className={styles.label}>
                Суб-суб Категорії <span className={styles.required}>*</span>
              </label>
              <div className={styles.checkboxGroup}>
                {filteredSubSubcategories.map((subsubcategory) => (
                  <div key={subsubcategory._id} className={styles.catButton}>
                    <div className={styles.checkboxWrapper22}>
                      <label
                        className={`${styles.switch} ${styles.round}`}
                        htmlFor={`subsubcategory-${subsubcategory._id}`}
                      >
                        <input
                          type="checkbox"
                          id={`subsubcategory-${subsubcategory._id}`}
                          value={subsubcategory._id}
                          checked={selectedSubSubcategory.includes(subsubcategory._id)}
                          onChange={handleSubSubcategoryChange}
                        />
                        <div className={styles.slider}></div>
                      </label>
                      <span style={{ marginLeft: "0.5rem" }}>
                        {subsubcategory.name}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* БЛОК ВИБОРУ ФІЛЬТРІВ */}
          {applicableFilters.length > 0 && (
            <>
              <label className={styles.label23}>
                Фільтри продуктів (Залежать від категорій):
              </label>
              <div className={styles.formGroup3}>
                {applicableFilters.map((filter) => (
                  <div key={filter._id} className={styles.checkboxGroup45}>
                    <div className={styles.filterGroup}>
                      <label className={styles.filterLabel}>
                        {filter.displayName}
                      </label>

                      {filter.isRange ? (
                        <div className={styles.rangeGroup}>
                          <input
                            className={styles.input}
                            type="number"
                            placeholder="Value"
                            value={selectedFilters[filter._id]?.value || ""}
                            onChange={(e) =>
                              setSelectedFilters((prev) => ({
                                ...prev,
                                [filter._id]: {
                                  value: e.target.value,
                                },
                              }))
                            }
                          />
                        </div>
                      ) : (
                        <div className={styles.checkboxGroup}>
                          {filter.values.map((valObj) => (
                            <div
                              key={valObj._id}
                              className={styles.catButton}
                            >
                              <div className={styles.checkboxWrapper22}>
                                <label
                                  className={`${styles.switch} ${styles.round}`}
                                  htmlFor={`filter-${filter._id}-${valObj._id}`}
                                >
                                  <input
                                    type="checkbox"
                                    id={`filter-${filter._id}-${valObj._id}`}
                                    value={valObj._id}
                                    checked={
                                      selectedFilters[filter._id]?.includes(valObj._id) ||
                                      false
                                    }
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setSelectedFilters((prev) => {
                                        const prevValues = prev[filter._id] || [];
                                        let newValues;
                                        if (checked) {
                                          newValues = [...prevValues, valObj._id];
                                        } else {
                                          newValues = prevValues.filter(
                                            (v) => v !== valObj._id
                                          );
                                        }
                                        return {
                                          ...prev,
                                          [filter._id]: newValues,
                                        };
                                      });
                                    }}
                                  />
                                  <div className={styles.slider}></div>
                                </label>
                                {/* Виводимо текстове значення (наприклад, "Red") */}
                                <span style={{ marginLeft: "0.5rem" }}>
                                  {valObj.value}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Вибір кольорів для основного продукту */}
          <div className={styles.formGroup}>
            <label className={styles.label}>Available Colors:</label>
            <div className={styles.checkboxGroup}>
              {colorsData.map((color, index) => (
                <label key={index} className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    id={color.name}
                    name="colors"
                    value={color.name}
                    onChange={handleColorSelection}
                  />
                  {color.name}
                </label>
              ))}
            </div>
          </div>

          {/* Головні зображення продукту */}
          <div className={styles.formGroup}>
            <label className={styles.label}>
              Фото продукту <span className={styles.required}>*</span>
            </label>
            <div className={styles.imageUpload}>
              <label htmlFor="upload" className={styles.uploadLabel}>
                <AiOutlinePlusCircle size={30} color="#555" />
              </label>
              {images.map((image, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <img
                    className={styles.uploadedImage}
                    src={image}
                    alt="Product"
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveImage(index)}
                    className={styles.deleteImageButton}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
            <input
              type="file"
              id="upload"
              className={styles.fileInput}
              multiple
              onChange={handleImageChange}
            />
          </div>

          {/* Субпродукти */}
          <div className={styles.subProductSection}>
            <div className={styles.subProductHeader}>
              <h5 className={styles.subProductTitle}>Суб-Продукти</h5>
              <button
                type="button"
                onClick={() => setShowSubProducts(!showSubProducts)}
                className={styles.toggleButton}
              >
                {showSubProducts ? "Приховати секцію" : "Показати секцію"}
              </button>
            </div>

            {showSubProducts && (
              <>
                <div className={styles.formGroup}>
                  <label className={styles.label}>
                    Назва Суб-Продукту <span className={styles.required}>*</span>
                  </label>
                  <input
                    className={styles.input}
                    type="text"
                    name="name"
                    value={subProduct.name}
                    onChange={handleSubProductChange}
                    placeholder="Введіть назву суб-продукту..."
                  />
                </div>

                <div className={styles.formGroup2}>
                  <div className={styles.price}>
                    <label className={styles.label}>
                      Ціна суб-продукту <span className={styles.required}>*</span>
                    </label>
                    <input
                      className={styles.input2}
                      type="number"
                      name="price"
                      value={subProduct.price}
                      onChange={handleSubProductChange}
                      placeholder="Введіть ціну суб-продукту..."
                    />
                  </div>
                  <div className={styles.price}>
                    <label className={styles.label}>
                      Ціна зі знижкою суб-продукту
                    </label>
                    <input
                      className={styles.input}
                      type="number"
                      name="discountPrice"
                      value={subProduct.discountPrice}
                      onChange={handleSubProductChange}
                      placeholder="Введіть ціну зі знижкою суб-продукту..."
                    />
                  </div>
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.label}>Colors:</label>
                  <div className={styles.checkboxGroup}>
                    {colorsData.map((color, index) => (
                      <label key={index} className={styles.checkboxLabel}>
                        <input
                          type="checkbox"
                          value={color.name}
                          checked={subProduct.colors.includes(color.name)}
                          onChange={handleSubProductColorChange}
                        />
                        {color.name}
                      </label>
                    ))}
                  </div>
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.label}>Фото субпродукту:</label>
                  <div className={styles.imageUpload}>
                    <label
                      htmlFor="subproduct-upload"
                      className={styles.uploadLabel}
                    >
                      <AiOutlinePlusCircle size={20} color="#555" />
                    </label>
                    <input
                      id="subproduct-upload"
                      className={styles.fileInput}
                      type="file"
                      multiple
                      onChange={handleSubProductImageChange}
                    />

                    <div className={styles.subproductImages}>
                      {subProduct.images.map((image, index) => (
                        <div
                          key={index}
                          style={{ position: "relative", display: "inline-block" }}
                        >
                          <img
                            className={styles.uploadedImage}
                            src={image}
                            alt="Sub Product"
                          />
                          <button
                            type="button"
                            onClick={() => handleRemoveSubProductImage(index)}
                            className={styles.deleteImageButton}
                          >
                            X
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={addSubProduct}
                  className={styles.addSubproductButton}
                >
                  Додати суб-продукт
                </button>

                {subProducts.length > 0 && (
                  <>
                    <div className={styles.subprodtitle}>
                      Список суб-продуктів
                    </div>
                    <ul className={styles.subproductsList}>
                      {subProducts.map((sp, index) => (
                        <li key={index} className={styles.subproductItem}>
                          <div className={styles.subproductInfo}>
                            <span className={styles.subproductName}>
                              Назва суб-продукту: {sp.name}
                            </span>
                            <span className={styles.subproductPrice}>
                              Ціна: {sp.price} грн
                            </span>
                          </div>
                          <div className={styles.subproductImagesWrapper}>
                            {sp.images?.map((img, imgIndex) => (
                              <div
                                key={imgIndex}
                                className={styles.subproductImageContainer}
                              >
                                <img
                                  src={img}
                                  alt={`${sp.name}`}
                                  className={styles.subproductImage}
                                />
                              </div>
                            ))}
                          </div>
                          <button
                            type="button"
                            onClick={() => handleRemoveSubProduct(index)}
                            className={styles.deleteSubproductButton}
                          >
                            X
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </>
            )}
          </div>

          <div className={styles.formGroup4}>
            <input
              type="submit"
              value="Створити продукт"
              className={styles.submitButton}
            />
            <input
              type="button"
              value="Очистити всі поля"
              className={styles.submitButton1}
              onClick={() => window.location.reload()}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProduct;
